import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-excel': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c9 9 14.1 21.3 14.1 34v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48.1h204.1c12.7 0 24.9 5.1 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM260 224c9.2 0 15 10 10.3 18-16 27.5-45.6 76.9-46.3 78l46.4 78c4.6 8-1.1 18-10.4 18h-28.8c-4.4 0-8.5-2.4-10.6-6.3-22.7-41.8-13.7-27.5-28.6-57.7-5.6 12.7-6.9 17.7-28.6 57.7-2.1 3.9-6.1 6.3-10.5 6.3h-28.9c-9.3 0-15.1-10-10.4-18l46.3-78-46.3-78c-4.6-8 1.1-18 10.4-18h28.9c4.4 0 8.5 2.4 10.6 6.3 21.7 40.4 14.7 28.6 28.6 57.7 6.4-15.3 10.6-24.6 28.6-57.7 2.1-3.9 6.1-6.3 10.5-6.3h28.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-excel.js
// module id = 1734
// module chunks = 0